import type { Business } from '../types/business';
import { isMultiSiteStockEnabled } from '../types/business';
import type { RolePermissions } from '../types/user';

/** Accès menu avatar → Statistiques par lieu (pas du paramétrage). */
export function canAccessSiteStats(params: {
  permissions: RolePermissions | null | undefined;
  business: Business | null | undefined;
}): boolean {
  const { permissions, business } = params;
  if (!isMultiSiteStockEnabled(business ?? null)) return false;
  return Boolean(
    permissions?.canViewCashReports ||
      permissions?.canViewDashboard ||
      permissions?.canViewPrestations ||
      permissions?.canViewProductSales
  );
}
